import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import {
	useCaseDetailsPageContext
} from '@components/CaseDetails/CaseDetailsContext/CaseDetailsPageContext/CaseDetailsPageContext';
import {
	CommentTypeFilter
} from '@components/CaseDetails/CommentsSection/CommentsSectionHeader/CommentTypeFilter/CommentTypeFilter';
import {
	ShowHistoryCheckbox
} from '@components/CaseDetails/CommentsSection/CommentsSectionHeader/ShowHistoryCheckbox/ShowHistoryCheckbox';
import {
	AddCommentButton
} from '@components/CaseDetails/CommentsSection/CommentsSectionHeader/AddCommentButton/AddCommentButton';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: theme.spacing(3, 3, 2, 3),
	},
	rootCondensed: {
		'alignItems': 'flex-start',
		'& > button': {
			marginTop: theme.spacing(3),
		},
	},
	title: {
		color: theme.palette.secondary.dark,
	},
	innerBoxExpanded: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '40%',
	},
	innerBoxCondensed: {
		width: '50%',
		display: 'flex',
		flexDirection: 'column',
	}
}));

interface CommentsHeaderProps {
	hideTitle?: boolean;
}

export const CommentsSectionHeader: React.FC<CommentsHeaderProps> = ({ hideTitle = false }) => {
	const classes = useStyles();
	const { showCondensedView } = useCaseDetailsPageContext();

	return (
		<Box className={classNames(classes.root, { [classes.rootCondensed]: showCondensedView })}>
			{!hideTitle && !showCondensedView && <Typography variant="h5" className={classes.title}>Comments</Typography>}
			<Box className={showCondensedView ? classes.innerBoxCondensed : classes.innerBoxExpanded}>
				<CommentTypeFilter />
				<ShowHistoryCheckbox />
			</Box>
			<AddCommentButton />
		</Box>
	);
};
